import {
  ProductListingActiveFilters,
  ProductListingHeader,
  ProductSidebar,
  ProductsList,
  ProductsPagination,
} from "@/components/organisms"
import { PRODUCT_LIMIT } from "@/const"
import { listProductsWithSort, listSellerProducts } from "@/lib/data/products"
import { StoreProduct } from "@medusajs/types"

export const ProductListing = async ({
  category_id,
  collection_id,
  seller_id,
  showSidebar = false,
  locale = process.env.NEXT_PUBLIC_DEFAULT_REGION,
  page = 1,
  q,
  seller_handle
}: {
  category_id?: string
  collection_id?: string
  seller_id?: string
  showSidebar?: boolean
  locale?: string
  page: number
  seller_handle?: string
  q?: string
}) => {

  if(!locale){
    locale = 'us';
    console.warn('No default region was configured, use us as default')
  }

  let response = {
    products: [] as StoreProduct[],
    count: 0
  };
  let id: string[] = [];

  if (seller_handle) {
    let sellerData = await listSellerProducts({
      handle: seller_handle,
      query: {
        fields: "id",
        offset: (page - 1) * PRODUCT_LIMIT,
        limit: PRODUCT_LIMIT,
      }
    })
    id = sellerData.products.map(p => p.id)
    if (id.length > 0) {
      let data = await listProductsWithSort({
        seller_id,
        category_id,
        collection_id,
        countryCode: locale,
        sortBy: "created_at",
        queryParams: {
          //@ts-ignore
          id,
          limit: PRODUCT_LIMIT,
          //@ts-ignore
          q
        },
      })
      response = data.response
      response.count = sellerData.count
    }
  } else {
    try {
      let data = await listProductsWithSort({
        seller_id,
        category_id,
        collection_id,
        countryCode: locale,
        sortBy: "created_at",
        queryParams: {
          offset: (page - 1) * PRODUCT_LIMIT,
          limit: PRODUCT_LIMIT,
          //@ts-ignore
          q
        },
      })
      response = data.response
    } catch (error) {
      console.error("ProductListing failed to load products:", error)
    }
  }

  const { products, count } = response

  if (count !== products.length) {
    console.warn("  ⚠️ 数量不匹配: count(", count, ") != products.length(", products.length, ")")
  }

  const pages = Math.ceil(count / PRODUCT_LIMIT) || 1

  showSidebar = false;

  return (
    <div className="py-2">
      <ProductListingHeader total={count} />
      <div className="hidden md:block">
        <ProductListingActiveFilters />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 mt-8 gap-4">
        {showSidebar && <ProductSidebar />}
        <section className={showSidebar ? "col-span-3" : "col-span-4"}>
          <ProductsList products={products} locale={locale}/>
          <ProductsPagination pages={pages} />
        </section>
      </div>
    </div>
  )
}
